import { Cast, Copy, Check, Mic, MicOff } from "lucide-react";

const ObsLinkRow = ({ obsUrl, obsCopied, onCopy }) => (
    <div className="flex gap-2">
        <input
            readOnly
            value={obsUrl || "Generating link..."}
            onFocus={(e) => e.target.select()}
            className="flex-1 min-w-0 bg-obsidian border border-white/10 text-white/80 px-3 py-2.5 font-mono text-xs outline-none focus:border-electric transition-colors"
            data-testid="obs-link-input"
        />
        <button
            onClick={onCopy}
            disabled={!obsUrl}
            className="px-4 bg-transparent border border-white/20 hover:border-white/60 disabled:opacity-30 disabled:cursor-not-allowed text-white font-mono uppercase text-[11px] tracking-[0.2em] flex items-center gap-2 transition-colors"
            data-testid="obs-copy-button"
        >
            {obsCopied ? <Check className="w-3.5 h-3.5 text-blaze" /> : <Copy className="w-3.5 h-3.5" />}
            {obsCopied ? "Copied" : "Copy"}
        </button>
    </div>
);

const MirrorStatus = ({ isLive }) => (
    <div
        className={`flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] ${
            isLive ? "text-blaze" : "text-white/30"
        }`}
        data-testid="obs-mirror-status"
    >
        <span className={`w-1.5 h-1.5 rounded-full ${isLive ? "bg-blaze live-pulse" : "bg-white/20"}`} />
        {isLive ? "Mirroring live output to OBS" : "Mirroring Awaiting Signal frame"}
    </div>
);

const MicToggleButton = ({ micOn, onToggleMic }) => (
    <button
        onClick={onToggleMic}
        data-testid="obs-mic-toggle"
        aria-pressed={micOn}
        className={`flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-2 border transition-colors ${
            micOn
                ? "border-blaze text-blaze bg-blaze/10"
                : "border-white/20 text-white/50 hover:border-white/50 hover:text-white"
        }`}
    >
        {micOn ? <Mic className="w-3.5 h-3.5" /> : <MicOff className="w-3.5 h-3.5" />}
        {micOn ? "Mic → OBS: On" : "Mic → OBS: Off"}
    </button>
);

export const ObsPanel = ({ obsUrl, obsCopied, onCopy, isLive, micOn, onToggleMic }) => (
    <div className="border border-white/10 bg-surface p-5" data-testid="obs-panel">
        <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/60 flex items-center gap-2">
                <Cast className="w-3 h-3 text-blaze" />
                OBS Integration
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/30">
                Browser Source · 1280×720
            </div>
        </div>
        <ObsLinkRow obsUrl={obsUrl} obsCopied={obsCopied} onCopy={onCopy} />
        <div className="mt-3 font-mono text-[10px] leading-relaxed text-white/40 uppercase tracking-[0.15em]">
            Paste this link into an OBS Browser Source. It mirrors your output panel exactly —
            including the Awaiting Signal frame — at full 30 FPS. No camera setup needed in OBS.
            Keep this Studio page open while streaming.
        </div>
        <div className="mt-3 flex items-center justify-between flex-wrap gap-3">
            <MirrorStatus isLive={isLive} />
            <MicToggleButton micOn={micOn} onToggleMic={onToggleMic} />
        </div>
    </div>
);
